import {formatDistance} from "date-fns";
import {NavLink, useHistory} from "react-router-dom";
import {PS_URLS, useCompanyId, useCurrentUser, usePlatformUrls} from "../../core";
import {AmProject, getStoreId} from "../../ps-types";
import {DeleteButton} from "../../ui/crud/DeleteButton.component";
import {buildEntityDef, EntityCrud} from "../../ui/crud/EntityCrud.component";
import {createAmProject, deleteAmProject, getAmProjects} from "./amProject.client";
import {Button} from "semantic-ui-react";
import { buildLineItemsStorePersistence } from "../../lineitems-store/RestLineItemsStore.persistence";
import { getAmProjectConfig } from "../../ps-models";
import { authStorage } from "../../auth";
import { StoreQuery } from "../../ps-models/lineitems-store";
import { useEffect, useState } from "react";
import { useMessages } from "../../ui/MessagesProvider";
import { LoadingBlock } from "../../ui/Loading";


function timeAgo(value: string) {
  return value ? formatDistance(new Date(value), new Date(), {addSuffix: true}) : "";
}

export function ProjectLink({project: p}: {project: AmProject}) {
  const { amProjectNewVersion, amProjectDetails } = usePlatformUrls();
  return p.name
  // return p.versions.length > 0 ?
    // <NavLink to={() => amProjectDetails(p.id)}>{p.name}</NavLink>:
    // <NavLink to={() => amProjectNewVersion(p.id)}>{p.name}</NavLink>
}

function DeleteBtn({entityName, entity, handleDelete}: {entityName: string, entity: any, handleDelete: (entity: any) => void}) {
  const content =`Are you sure you want to delete the ${entityName} '${entity["name"]}'?`;

  return <DeleteButton
    content={content}
    onDelete={() => handleDelete(entity)}
  />
}

export interface ProjectListingOptions {
  title?: string
  getProjects?: () => Promise<AmProject[]>;
}

const persistence = buildLineItemsStorePersistence();

export function QBTProjectsList(options: ProjectListingOptions = {}) {
  const history = useHistory();


  const companyId = useCompanyId();
  const user = useCurrentUser();

  const getEntities = options.getProjects || (() => getAmProjects(companyId));
  const createEntity =  async () => {
    history.push(PS_URLS(companyId).developmentProjectsProjectCreation())
  }

  const deleteEntity = (project: any) => deleteAmProject(companyId, project.id);

  let def = buildEntityDef(
    {
      entityName: "Project",
      title: options.title || "My Projects",
      getEntities,
      // deleteEntity: user.data.readOnly ? undefined : deleteEntity,
      table: {
        tableComponent: 'dataGrid',
        // deleteButton: user.data.readOnly ? undefined : (props)=> (<DeleteBtn {...props} />)
      }
    },
    {
      name: {
        table: {
          render: (_value: string, project) =>
            <ProjectLink project={project as AmProject} />
        }
      },
      createdAt: {
        title: "CREATED",
        create: { type: "hidden" },
        table: { format: timeAgo }
      },
      "defaultVersionData.id": {
        title: "PROJECT ID",
        table: {
          format: (value: string, project) => {
            if(value){
              return value;
            } else {
              return project.id;
            }
          }
        },
        create: { type: "hidden" },
      },
      defaultVersion: {
        title: "DEFAULT VERSION",
        table: {
          format: (value: string, project) => project.versions.find((v: any) => v.versionId === value)?.title || ""
        },
        create: { type: "hidden" },
      },
      "Default Version Description": { // This is a dummy field name
        title: "DESCRIPTION",
        table: {
          format: (_value: string, project) => {
            const defaultVer = project.versions.find((v: any) => v.versionId === project.defaultVersion)
            let description = defaultVer?.description;
            return `${description || ""}`
          }
        },
        create: { type: "hidden" },
      },
      fileProcessedAt: {
        title: "EXCEL LAST PROCESSED",
        create: { type: "hidden" },
        table: { format: timeAgo }
      },
      status: {
        title: "STATUS",
        create: { type: "hidden" },
        table: {
          render: (_value: string, project) =>
            <ProjectStatus project={project as AmProject} />
        }
      }
    }
  );

  return <div>
        <Button primary
                floated={"right"}
                style={{marginBottom: "1em"}}
                size={"small"}
                onClick={createEntity}
        >Add Project</Button>
    <EntityCrud entityDef={def} />
  </div>
}

function ProjectStatus({project}: {project: AmProject}) {
  const [status, setStatus] = useState<string | null>(null);  
  const [loading, setLoading] = useState<boolean>(true);
  const company = authStorage.getCompany();
  let { collection } = getAmProjectConfig(company);

  useEffect(() => {
    async function load() {
      const store = await persistence.loadLineItemsStore(collection, getStoreId(project.id, project?.defaultVersion as string ?? project.id), false)
      let results = store.query(StoreQuery.byNames(['System Cost and Capital-DSCR', 'System Cost and Capital-MOIC', 'System Cost and Capital-Project Post Tax IRR']))
      const isProjectEconomicsPassed = (results?.lastTimeSlotValueOf('System Cost and Capital-DSCR') as number ?? 0 >= 1) && (results?.lastTimeSlotValueOf('System Cost and Capital-MOIC') as number ?? 0 >= 1.2) && (results?.lastTimeSlotValueOf('System Cost and Capital-Project Post Tax IRR') as number ?? 0 >= 0.08);
      setStatus(isProjectEconomicsPassed ? 'Qualification success' : 'Qualification fail');
      return isProjectEconomicsPassed ? 'Qualification success' : 'Qualification fail';
    }
    setLoading(true);
    load().catch(e => console.error(e)).finally(() => setLoading(false));
  }, [project]);

  return loading ? <div><LoadingBlock /></div> : <div style={{color:status === 'Qualification success' ? 'green' : 'orange'}}>{status}</div>
}